import { Table } from '@pukka/ui-components';

import { Outlet } from './Billing.state';
import { BillingContent } from './BillingContent';

const columns = [
  {
    header: 'Outlet Name',
    accessorKey: 'name',
  },
  {
    header: 'Expiry Date',
    accessorKey: 'expiry',
  },
];

interface BillingActiveOutletProps {
  readonly outlets?: readonly Outlet[];
}

const defaultOutlets: Outlet[] = [];

function BillingActiveOutlet({ outlets = defaultOutlets }: BillingActiveOutletProps) {
  return (
    <BillingContent title="Active Outlet">
      <Table rounded data={outlets as Outlet[]} columns={columns} />
    </BillingContent>
  );
}

export { BillingActiveOutlet };
